<h1 class="title">CUEA Digital Repository</h1>

<p>
  Welcome to The Catholic University of Eastern Africa Digital Repository.
  Access research papers, theses, past papers, and publications.
</p>

<a class="btn btn-primary" href="https://cuea.edu">Visit CUEA Website</a>
